import { render, staticRenderFns } from "./duo_question_note.vue.js?vue&type=template&id=fcbde072!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./duo_question_note.vue?vue&type=template&id=fcbde072"
import script from "./duo_question_note.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./duo_question_note.vue?vue&type=script&lang=js"
export * from "./duo_question_note.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./duo_question_note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports